import { Form } from 'antd';
import { useTranslations } from 'next-intl';
import { PatternFormat } from 'react-number-format';

interface IProps {
  disabled?: boolean;
}

export function PhoneInput({ disabled }: IProps) {
  const t = useTranslations('auth');

  return (
    <Form.Item
      name="phone"
      label={t('phone_validation_message')}
      rules={[{ required: true, message: t('telefon_raqam_xato') }]}
    >
      <PatternFormat
        format="+998 ## ### ## ##"
        allowEmptyFormatting
        mask=" "
        disabled={disabled}
        className="!h-11 !w-full !p-3 hover:!outline-green-500 focus:!outline-green-500 !rounded-lg !bg-gray-50 !border !border-gray-200 disabled:hover:border-gray-400"
      />
    </Form.Item>
  );
}
